// extracted by mini-css-extract-plugin
export default {"modalbackdrop":"NewModal_modalbackdrop__qL8Py","modalcontent":"NewModal_modalcontent__iuX0t"};